import React from "react";
import { AbsoluteFill } from "remotion";
import { Lottie } from "@remotion/lottie";
import { AnimationItem } from "lottie-web";
import { useCallback } from "react";
import animationData from "../../assets/Recruit_US_Map_Shapes_v2.json";

export const UsMap = () => {
  return ( 
    <>
    <AbsoluteFill>
        <Lottie 
        animationData={animationData}
        playbackRate={.4}
        />
    </AbsoluteFill>
    </>
    )
};


